import { normalizeRelativePath } from './normalizeRelativePath.js';
/**
 * Parse an import path: usually this will be a standard JS import, but this function also allows
 * an optional `@version` suffix after the package name.
 *
 * Examples of supported import strings:
 * - `foo`
 * - `foo@1.2.3`
 * - `foo@1.2.3/path/to/file`
 * - `@foo/bar`
 * - `@foo/bar@1.2.3`
 * - `@foo/bar@1.2.3/path/to/file`
 * - `foo/lib/something$normalization.graphql`
 */
export function parseImportString(importString = '') {
    if (/^\.\.?\//.test(importString)) {
        // If it's a relative path (with forward slash), return as-is, since it doesn't need normalization
        // and won't have a version
        return { packageName: '.', version: '', importPath: importString };
    }
    const matches = importString.match(
    //   1: packageName          2: version      3: importPath
    /^\/?((?:@[-\w.]+\/)?[-\w.:]+)(?:@([-\w.]+))?(\/[\w./$:-]*\/?)?/) || [];
    return {
        packageName: matches[1] || '.',
        version: matches[2] || '',
        importPath: normalizeRelativePath(matches[3]),
    };
}
//# sourceMappingURL=parseImportString.js.map